import PriceExtrasDesktop from '../../../../components/price/components/price-extras/price-extras.desktop';
import priceExtrasModule from './price-extras';

export default priceExtrasModule(PriceExtrasDesktop);
